import React, { useState } from 'react';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'

export default function Thermal_Render(props) {
  const { setNodeData, nodeData } = props;
  const [on, setToggle] = useState(nodeData.type === "thermal"? nodeData.on: true);
  setNodeData({
    type: "thermal",
    on: on
  })
  const handleChange = (event) => {
    setToggle(event.target.checked)
    console.log(event.target.checked)
    setNodeData({
      type: "thermal",
      on: event.target.checked
    })
  }

    return(<Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{display: "flex", alignItems:'center', justifyContent:"center", flexDirection: "row"}}>
      <Typography>Off</Typography>
      <Switch onChange={handleChange} checked={on}></Switch>
      <Typography>On</Typography>
    </Grid>)
}